import React, { type ComponentPropsWithoutRef } from 'react';
import Watchers from './main';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: ComponentPropsWithoutRef<typeof Watchers>) => {
	if (!props.configs?.canManageWatchers) {
		return null;
	}
	return <Watchers {...props} />;
};
